export const GET_USER_DATA = 'GET_USER_DATA'
export const GET_GROUP_DATA = 'GET_GROUP_DATA'
export const GET_TABLE_DATA = 'GET_TABLE_DATA'
export const SHOW_LOADER = 'SHOW_LOADER'
export const HIDE_LOADER = 'HIDE_LOADER'
export const SHOW_404 = 'SHOW_404'
export const HIDE_404 = 'HIDE_404'
export const MAIN_REQUEST = 'MAIN_REQUEST'
export const CHANGE_MENU_ITEM = 'CHANGE_MENU_ITEM'
export const CHANGE_MENU_SUBITEM = 'CHANGE_MENU_SUBITEM'
export const TABLE_REQUEST = 'TABLE_REQUEST'
export const CHANGE_SEARCH_WORD = 'CHANGE_SEARCH_WORD'
export const CHANGE_SEARCH_ITEMS = 'CHANGE_SEARCH_ITEMS'
export const CLEAR_SEARCH_ITEMS = 'CLEAR_SEARCH_ITEMS'
export const ADD_SEARCHED_USER = 'ADD_SEARCHED_USER'
export const QAA_CLICK = 'QAA_CLICK'
export const CHANGE_LANG = 'CHANGE_LANG'
export const GIFT_POPUP = 'GIFT_POPUP'
export const USER_POPUP = 'USER_POPUP'
export const MOBILE_POPUP = 'MOBILE_POPUP'
export const MOBILE_LANG = 'MOBILE_LANG'
export const SUMMARY = 'SUMMARY'
export const SUMMARY_REQUEST = 'SUMMARY_REQUEST'
export const SUMMARY_POPUP = 'SUMMARY_POPUP'
export const SET_GAME = 'SET_GAME'
export const SET_SPIN_READY = 'SET_SPIN_READY'
export const SET_SPIN_NOT_READY = 'SET_SPIN_NOT_READY'
export const SET_CODE = 'SET_CODE'
export const CODE_POPUP = 'CODE_POPUP'
export const RECEIVED_GIFT_POPUP = 'RECEIVED_GIFT_POPUP'
export const RECIVED_GIFT = 'RECIVED_GIFT'
export const RECEIVED_SHOP_GIFT_POPUP = 'RECEIVED_SHOP_GIFT_POPUP'
export const RECIVED_SHOP_GIFT = 'RECIVED_SHOP_GIFT'
export const WINNERS_POPUP = 'WINNERS_POPUP'
export const GIFTSLIST_POPUP = 'GIFTSLIST_POPUP'
export const ADD_WHEEL_WINNERS = 'ADD_WHEEL_WINNERS'
export const ADD_SHOP_WINNERS = 'ADD_SHOP_WINNERS'
export const WHEEL_PAGINATION = 'WHEEL_PAGINATION'
export const SHOP_PAGINATION = 'SHOP_PAGINATION'
export const WHEEL_ANIMATION = 'WHEEL_ANIMATION'
export const GET_ERROR_ALERT = 'GET_ERROR_ALERT'
export const CLOSE_ERROR_ALERT = 'CLOSE_ERROR_ALERT'
export const WHEEL_DEG = 'WHEEL_DEG'
export const SHOW_SEARCH_LOADER = 'SHOW_SEARCH_LOADER'
export const HIDE_SEARCH_LOADER = 'HIDE_SEARCH_LOADER'
export const SHOW_CODE_LOADER = 'SHOW_CODE_LOADER'
export const HIDE_CODE_LOADER = 'HIDE_CODE_LOADER'
export const CLEAN_RECEIVED_GIFT = 'CLEAN_RECEIVED_GIFT'
export const CLEAN_RECEIVED_SHOP_GIFT = 'CLEAN_RECEIVED_SHOP_GIFT'
export const SET_GROUP = 'SET_GROUP'
export const LOGIN_POPUP = 'LOGIN_POPUP'
export const SET_TOKEN = 'SET_TOKEN'
export const SHOW_LOGIN_LOADER = 'SHOW_LOGIN_LOADER'
export const HIDE_LOGIN_LOADER = 'HIDE_LOGIN_LOADER'
export const SET_LOGIN = 'SET_LOGIN'
export const SET_POINTS = 'SET_POINTS'
export const SET_SELECTED_GIFT = 'SET_SELECTED_GIFT'
export const GIFT_POPUP_LOADING = 'GIFT_POPUP_LOADING'
export const SUBSTRACT_POINTS = 'SUBSTRACT_POINTS'
export const ALL_WHEEL_WINNERS = 'ALL_WHEEL_WINNERS'
export const ALL_SHOP_WINNERS = 'ALL_SHOP_WINNERS'
export const SHOP_WINNERS_POPUP = 'SHOP_WINNERS_POPUP'
export const CONFIRM_SPIN_POPUP = 'CONFIRM_SPIN_POPUP'
export const CONFIRM_GIFT_POPUP = 'CONFIRM_GIFT_POPUP'
export const CONFIRM_POPUP_LOADING = 'CONFIRM_POPUP_LOADING'
export const SET_REMAIN_POINTS = 'SET_REMAIN_POINTS'
export const SET_SHOP_GIFTS = 'SET_SHOP_GIFTS'
